module.exports = "/assets/pattern-bfw-2.png?HZOW9PG";